import { useCallback, useMemo } from 'react'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ICampaign } from '@user/store/campaigns'
import { useSelector } from 'react-redux'
import { activeCampaigns, selectAllCampaigns } from '@user/store/campaigns'
import { activeSources, selectAllSources } from '@user/store/sources'

type Props = {
  name: string
  required: boolean
  leadSourceRequired: boolean
}

export function useHandlers(props: Props) {
  const { required, leadSourceRequired } = props
  const { setValues } = useFormikContext<IAddOpportunityFormModel>()

  const campaigns = useSelector(selectAllCampaigns)
  const leadSources = useSelector(selectAllSources)

  const activeLeadCampaigns = useMemo(
    () => activeCampaigns(campaigns, required),
    [campaigns, required],
  )

  const activeLeadSources = useMemo(
    () => activeSources(leadSources, leadSourceRequired),
    [leadSources, leadSourceRequired],
  )

  const handelChange = useCallback((value: ICampaign | null) => {
    const foundCampaign = activeLeadCampaigns.find((x) => x.id === value?.id)
    const foundLeadSource = activeLeadSources.find(
      (x) => x.name === foundCampaign?.source,
    )
    if (foundCampaign) {
      if (foundLeadSource) {
        setValues((v) => ({
          ...v,
          leadSource: foundLeadSource.name,
          leadSourceId: foundLeadSource.id,
          campaign: foundCampaign.name,
          campaignId: foundCampaign.id,
        }))
      }
      if (!foundLeadSource) {
        setValues((v) => ({
          ...v,
          campaign: foundCampaign.name,
          campaignId: foundCampaign.id,
        }))
      }
    }
  }, [])
  return {
    handelChange,
  }
}
